import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/surrogacy/wellness-monitoring/#webpage",
   "url": "https://www.futurefamilyai.com/surrogacy/wellness-monitoring/",
   "name": "Surrogate Wellness Monitoring App | FutureFamilyAI",
   "description": "Wellness monitoring built for gestational surrogates: validated-cuff BP, wearable trends and care-team review — with you in full control of sharing.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Pooja Patel, MD",
    "jobTitle": "Surrogacy & Fertility Content Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#pooja-patel",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Surrogate Wellness",
     "item": "https://www.futurefamilyai.com/surrogacy/wellness-monitoring/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Is there a health monitoring app for surrogates?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. FutureFamilyAI includes a surrogate pathway with validated-cuff blood pressure tracking, wearable trends, symptom logging and care-team review, plus surrogate-controlled sharing."
     }
    },
    {
     "@type": "Question",
     "name": "Can intended parents see my health data?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Only if you choose. You can share a summary, trends or nothing at all, and change your mind at any time."
     }
    },
    {
     "@type": "Question",
     "name": "Does my surrogacy agency pay for FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Many participating agencies provide it to surrogates at no cost. During the pilot, there is also no subscription fee for eligible participants through December 31, 2026."
     }
    },
    {
     "@type": "Question",
     "name": "Do I have to use FutureFamilyAI as a surrogate?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Participation is voluntary and should never be a condition of your surrogacy agreement unless you and your legal counsel agree."
     }
    },
    {
     "@type": "Question",
     "name": "Does the app replace my OB?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Your obstetric team remains responsible for your care. FutureFamilyAI gives them more context between visits if you choose to share."
     }
    },
    {
     "@type": "Question",
     "name": "Can independent surrogates use FutureFamilyAI?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Independent surrogates can enroll directly, subject to eligibility."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  },
  {
   "@type": "MobileApplication",
   "name": "FutureFamilyAI",
   "operatingSystem": "iOS, Android",
   "applicationCategory": "HealthApplication",
   "offers": [
    {
     "@type": "Offer",
     "price": "0",
     "priceCurrency": "USD",
     "description": "Free pilot through December 31, 2026",
     "priceValidUntil": "2026-12-31"
    },
    {
     "@type": "Offer",
     "price": "39.99",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, monthly (after pilot)"
    },
    {
     "@type": "Offer",
     "price": "399",
     "priceCurrency": "USD",
     "description": "Complete Monitoring, annual (after pilot)"
    }
   ],
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   }
  }
 ]
}`;

export default function SurrogacyWellnessMonitoringPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <span>Surrogate Wellness</span>
            </nav>

            <div className="topvideo_section">
              <div className=" row">
                <div className=" col-md-6">
                  {/* <span className="ffh-eyebrow">Physician-connected pregnancy wellness</span> */}
                  <h1>
                    Compassionate Care for Every Surrogacy Journey
                  </h1>

                  <p className="ffh-lead speakable-content">
                    Support surrogate wellness with pregnancy blood pressure tracking, wellness trends, and care-team-reviewed alerts. FutureFamilyAI helps surrogates stay connected with their healthcare providers while supporting consent-based care coordination throughout pregnancy and postpartum recovery.
                  </p>
                  <p style={{ fontSize: "1.25rem", fontWeight: "700", color: "var(--blue-ink)" }}>
                    Wellness Monitoring. Connected Support. Care With Confidence.
                  </p>
                  <div class="ffh-cta-row">
                    <a class="ffh-btn ffh-primary" href="#">Download the App </a>
                    <a class="ffh-btn ffh-ghost" href="/contact-us?type=member" data-discover="true">Explore How It Works</a>
                  </div>
                </div>
                <div className="col-md-6" aria-label="Example FutureFamilyAI app screen (illustrative)">
                  <iframe
                    width="100%"
                    height="365"
                    src="https://www.youtube.com/embed/Cs-YeVEReo4?rel=0"
                    title="Surrogate Wellness Monitoring Between Prenatal Visits | FutureFamilyAI"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>

            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Surrogate wellness monitoring gives gestational surrogates an
                easy way to track blood pressure, heart rate, sleep and symptoms
                between visits, with care-team review when a pattern needs
                attention.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Gestational surrogates</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      Hypertensive disorders were present in about 1 in 7 U.S.
                      delivery hospitalizations (2017–2019). (CDC, MMWR 2022)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      You own your data — sharing is opt-in per person · Fewer
                      check-in calls, clearer updates · Often provided free
                      through your agency
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact-us/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">FOR GESTATIONAL SURROGATES</span>
            <h1>Surrogate Wellness Monitoring — Support That Respects You</h1>
            <p className="ffh-answer speakable-content">
              Surrogate wellness monitoring gives gestational surrogates an easy
              way to track blood pressure, heart rate, sleep and symptoms
              between visits, with care-team review when a pattern needs
              attention. FutureFamilyAI puts the surrogate in control: intended
              parents and coordinators see only what she chooses to share. It is
              often provided at no cost through participating agencies. Explore
              surrogate support.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#pooja-patel">Dr. Pooja Patel, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Gestational surrogate using FutureFamilyAI to track her wellness at home"
              >
                <img
                  src="/images/gestational-surrogate.jpg"
                  alt="Gestational surrogate using FutureFamilyAI to  track her wellness at home" className="ffh-photo-img" />

              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    Hypertensive disorders were present in about 1 in 7 U.S.
                    delivery hospitalizations (2017–2019).
                    <cite>
                      Source:{" "}
                      <a href="https://www.cdc.gov/mmwr/volumes/71/wr/mm7117a1.htm">
                        CDC, MMWR 2022
                      </a>
                    </cite>
                  </li>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>
                  You&apos;re carrying for someone else — your health still
                  comes first
                </h2>
                <p>
                  Surrogates take on a pregnancy with extra appointments, extra
                  people asking for updates and extra pressure. FutureFamilyAI
                  gives you one simple daily routine and a clear status, so you
                  can focus on your own wellbeing.
                </p>
              </section>
              <section id="s2">
                <h2>Privacy designed around the surrogate</h2>
                <ul>
                  <li>Nothing is shared by default.</li>
                  <li>
                    Choose each person — clinician, coordinator, intended
                    parents — individually.
                  </li>
                  <li>
                    Choose what they see: readings, trends or a weekly summary.
                  </li>
                  <li>Revoke access at any time.</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="s3">
                <h2>Fewer calls, better updates</h2>
                <p>
                  With your permission, intended parents can receive a simple
                  summary instead of texting you for news. Coordinators can help
                  with logistics without seeing private health details you
                  haven&apos;t shared.
                </p>
              </section>
              <section id="s4">
                <h2>Backed by people who know surrogacy</h2>
                <p>
                  FutureFamilyAI is used by Surrogacy4All to support its
                  gestational surrogates. Surrogacy content is authored by Dr.
                  Pooja Patel, MD, and reviewed by Dr. Rashmi Gulati, MD.
                </p>
              </section>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      Is there a health monitoring app for surrogates?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. FutureFamilyAI includes a surrogate pathway with
                        validated-cuff blood pressure tracking, wearable trends,
                        symptom logging and care-team review, plus
                        surrogate-controlled sharing.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can intended parents see my health data?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Only if you choose. You can share a summary, trends or
                        nothing at all, and change your mind at any time.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does my surrogacy agency pay for FutureFamilyAI?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Many participating agencies provide it to surrogates at
                        no cost. During the pilot, there is also no subscription
                        fee for eligible participants through December 31, 2026.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Do I have to use FutureFamilyAI as a surrogate?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. Participation is voluntary and should never be a
                        condition of your surrogacy agreement unless you and
                        your legal counsel agree.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Does the app replace my OB?</summary>
                    <div className="ffh-ans">
                      <p>
                        No. Your obstetric team remains responsible for your
                        care. FutureFamilyAI gives them more context between
                        visits if you choose to share.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can independent surrogates use FutureFamilyAI?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        Yes. Independent surrogates can enroll directly, subject
                        to eligibility.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">PP</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Pooja Patel, MD</h3>
                  <p>
                    Surrogacy &amp; Fertility Content Author, FutureFamilyAI.
                    Dr. Pooja Patel, MD, writes FutureFamilyAI&apos;s surrogacy
                    and fertility content. Her work across the Surrogacy4All
                    network focuses on gestational carriers, IVF preparation and
                    family-building pathways.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/surrogacy/surrogate-health-monitoring-app">
                    Surrogate Health Monitoring App →
                  </Link>
                  <Link to="/surrogacy/surrogate-blood-pressure-tracking">
                    Surrogate Blood Pressure Tracking →
                  </Link>
                  <Link to="/surrogacy/intended-parent-updates">
                    Intended Parent Updates →
                  </Link>
                  <Link to="/surrogacy/coordinator-role-wellness-app">
                    Coordinator Role →
                  </Link>
                  <Link to="/surrogacy/independent-surrogate-agencies">
                    Independent Surrogates →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">
                      You&apos;re carrying for someone else — your health still
                      comes first
                    </a>
                  </li>
                  <li>
                    <a href="#s2">Privacy designed around the surrogate</a>
                  </li>
                  <li>
                    <a href="#s3">Fewer calls, better updates</a>
                  </li>
                  <li>
                    <a href="#s4">Backed by people who know surrogacy</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
